export default "__VITE_ASSET__881a9189__"